module.exports = __webpack_public_path__ + "static/media/EASY-BNB.6570f7ad.svg";